import React from 'react'
import parse from 'html-react-parser'
import { Link, useParams } from 'react-router-dom';
import { usePublication } from '../../../hooks/usePublication';
// import { usePublication } from '../../../hooks/usePublication';
import LeftMenuResources from './LeftMenuResources';
import LeftMenuSection from './LeftMenuSection';
import { findTypeOption, typeLibro } from '../../../interfaces/Publication';

const LeftMenu = () => {


  const { publication } = usePublication()

  let { idRevista, idLibro } = useParams();
  const typeLibro: typeLibro = idLibro ? "libro" : "revista"
  const route = findTypeOption(typeLibro)?.route || ""
  // const fileName = findTypeOption(typeLibro)?.fileName || ""


  const openCredits = () => {


    const credits = document.getElementById("creditos");
    const backdrop = document.querySelector(".js-backdrop");

    if (credits && backdrop) {
      credits.classList.toggle("visible-slideup")
      backdrop.classList.add("visible-fadein");
    }
    // modal modal--bg visible-slideup
  }

  const openLeftMenu = () => {

    const icoBtn: Element | null = document.querySelector(".js-btn-icon");
    const menu = document.querySelector(".js-nav");
    const asideBtn = document.querySelectorAll(".gui__group--right .aside-btn");
    const colRight = document.querySelector(".aside");


    if (icoBtn) { icoBtn.classList.toggle("close-icon") }
    menu && menu.classList.toggle("expand")
    // if(asideBtn.classList.contains("focus")){
    //   item.classList.remove("focus");
    // }
    asideBtn && asideBtn.forEach((item) => {
      if (item.classList.contains("focus")) {
        item.classList.remove("focus");
      }
      //   console.log(item);
    })


    if (colRight && colRight.classList.contains("expanded")) {
      colRight.classList.remove("expanded");
      //asideBtn.classList.remove("focus");
    } else {
      //document.querySelector("#" + opt).classList.add("active");
    }

  }


  return (
    <>
      {/* <!-- [left] section --> */}
      <div className="l1-wrapper__left">
        <div className="nav">
          <div className="nav-wrapper js-nav">


            <div className="nav-header">
              <button type="button" id="options-btn-m" className="btn btn-rounded js-btn-aside-m tippy hide-lg" data-tippy-content="Indice de contenidos" aria-label="Indice de contenidos" onClick={openLeftMenu}>
                <span className="btn__close-icon">
                  <i className="icon icon-vpro-close"></i>
                </span>
              </button>
              <div className="nav-header__title">
                <div className="brand">
                  {/* <!-- <img src="./public/images/vpro_logo.png" alt="Virtualpro" /> --> */}
                  <svg
                    className="vpro-logo"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 585.25 64.9"
                  >

                    <g id="c">
                      <g id="d">
                        <path
                          className="logo-fill"
                          d="M158.86 8.51h21.28v56.37h12.62V8.51h21.28V0h-55.18v8.51zM262.94 0c0 10.61.02 41.68.02 41.8 0 8.03-6.54 14.57-14.57 14.57h-.41c-8.04 0-14.57-6.54-14.57-14.57 0-.13 0-31.19.02-41.8h-12.84v40.59c0 14.31 11.26 24.3 27.39 24.3h.41c16.13 0 27.39-9.99 27.39-24.3 0-.12-.02-29.96-.02-40.58h-12.82ZM34.27 54.41a2.647 2.647 0 0 1-2.56 1.97h-.83c-1.21 0-2.26-.82-2.57-1.98L12.84 0H0l18.01 61.07a5.35 5.35 0 0 0 5.11 3.82h16.36c2.34 0 4.44-1.57 5.11-3.82L62.6 0H49.76L34.28 54.41ZM318.53 0h-16.36c-2.34 0-4.44 1.57-5.11 3.82l-18.01 61.07h12.84l15.48-54.39c.3-1.17 1.36-1.98 2.57-1.98h.83c1.21 0 2.26.82 2.56 1.97l15.48 54.41h12.84L323.63 3.82a5.346 5.346 0 0 0-5.1-3.82ZM75.68 0h12.84v64.88H75.68zM145.99 40.68c6.48-3.79 10.84-10.82 10.84-18.85C156.83 9.79 147.04 0 134.98 0h-33.37v64.88h12.84V43.66h16.22c.67 0 1.34.1 1.98.3 1.65.5 3.11 1.64 3.99 3.28l2.16 4.06 7.22 13.58h12.84l-7.22-13.58-5.65-10.62Zm-15.33-5.53h-16.22V8.51h16.22c7.35 0 13.32 5.98 13.32 13.32S138 35.15 130.66 35.15ZM557.86 0h-9.23c-15.1 0-27.39 12.29-27.39 27.39v10.1c0 15.1 12.29 27.39 27.39 27.39h9.23c15.1 0 27.39-12.29 27.39-27.39v-10.1c0-15.1-12.28-27.39-27.39-27.39Zm14.55 41.8c0 8.03-6.54 14.57-14.57 14.57h-9.19c-8.03 0-14.57-6.54-14.57-14.57V23.08c0-8.03 6.54-14.57 14.57-14.57h9.19c8.03 0 14.57 6.54 14.57 14.57V41.8ZM361.03 0h-12.84v64.88h44.21v-8.5h-31.37V0zM432.32 0h-33.37v64.88h12.84V43.66h20.55c12.04 0 21.83-9.79 21.83-21.83S444.37 0 432.32 0Zm-4.31 35.16h-16.22V8.51h16.22c7.35 0 13.32 5.98 13.32 13.32s-5.98 13.32-13.32 13.32ZM505.1 40.68c6.48-3.79 10.84-10.82 10.84-18.85C515.94 9.79 506.15 0 494.09 0h-33.37v64.88h12.84V43.66h16.22c.67 0 1.34.1 1.98.3 1.65.5 3.11 1.64 3.99 3.28l2.16 4.06 7.22 13.58h12.84l-7.22-13.58-5.65-10.62Zm-15.33-5.53h-16.22V8.51h16.22c7.35 0 13.32 5.98 13.32 13.32s-5.98 13.32-13.32 13.32Z"
                        />
                      </g>
                    </g>
                  </svg>
                </div>
                <div className="nav-header__title-title">{parse(publication.title)}</div>
              </div>
            </div>

            <div className="nav main-sb">
              <ul className="nav__menu unstyled-list">
                <li className="nav__menu-divider">Índice</li>
                <li className="nav__menu-item">
                  <Link to={`/${route}/${publication.id}`} className="nav__link" >Portada</Link>
                </li>

                {
                  publication.sections.map((section, index) => (
                    <LeftMenuSection
                      key={index}
                      section={section}
                      index={index}
                      toggleMenu={openLeftMenu}
                    ></LeftMenuSection>

                  ))
                }

                <li className="nav__menu-divider">Recursos</li>
                <LeftMenuResources
                  sections={publication.sections}
                ></LeftMenuResources>




              </ul>
            </div>
            <div className="nav">
              <ul className="nav__menu unstyled-list">
                <li className="nav__menu-item">
                  <button
                    type="button"
                    className="nav__link btn-primary btn--fw js-btn-modal"
                    data-modal-trigger="creditos"
                    onClick={openCredits}
                  >
                    Créditos
                  </button>
                  {/* <!-- <a className="nav__link" data-modal-trigger="creditos"
                    >Créditos</a
                  > --> */}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- [left] section end -->             */}
    </>
  )
}

export default LeftMenu
